export default "__VITE_ASSET__2kzXN54e__"